// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iframeModal[data-v-bd148a0c],.iframeModalAcc[data-v-bd148a0c]{width:100%;height:50vh;overflow:hidden}@media screen and (max-width:768px){.modal-dialog[data-v-bd148a0c]{max-width:100%}.iframeModal[data-v-bd148a0c]{height:50vh}}", ""]);
// Exports
module.exports = exports;
